/**
 * AccountController
 *
 * @return {void}
 */
const AccountController = () => {
  if($('.js-order-history-toggle').length > 0) {
    if(window.location.href.indexOf('page=') !== -1) {
      $('.js-order-history').addClass('show');
    }
    $('.js-order-history-toggle').on('click', (e) => {
      e.preventDefault();
      $('.js-order-history').addClass('show');
    });
  }
};

export default AccountController;



// WEBPACK FOOTER //
// ./src/js/controllers/AccountController.js